import { render, staticRenderFns } from "./ListGroup.vue?vue&type=template&id=c40378bc&scoped=true"
import script from "./ListGroup.vue?vue&type=script&lang=js"
export * from "./ListGroup.vue?vue&type=script&lang=js"
import style0 from "./ListGroup.vue?vue&type=style&index=0&id=c40378bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c40378bc",
  null
  
)

export default component.exports